import React from 'react';

interface EduBadgeProps {
  children: React.ReactNode;
  variant?: 'success' | 'warning' | 'error' | 'info' | 'neutral' | 'orange';
  size?: 'sm' | 'md';
  dot?: boolean;
}

export const EduBadge: React.FC<EduBadgeProps> = ({
  children,
  variant = 'neutral',
  size = 'md',
  dot = false,
}) => {
  const variantStyles = {
    success: 'bg-green-50 text-status-success border-green-200',
    warning: 'bg-amber-50 text-status-warning border-amber-200',
    error: 'bg-red-50 text-status-error border-red-200',
    info: 'bg-blue-50 text-status-info border-blue-200',
    orange: 'bg-brand-light text-brand-primary border-orange-200',
    neutral: 'bg-slate-100 text-txt-secondary border-slate-200',
  };

  const dotColors = {
    success: 'bg-status-success',
    warning: 'bg-status-warning',
    error: 'bg-status-error',
    info: 'bg-status-info',
    orange: 'bg-brand-primary',
    neutral: 'bg-txt-muted',
  };

  const sizeStyles = {
    sm: 'text-xs px-2 py-0.5',
    md: 'text-xs font-medium px-2.5 py-1',
  };

  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border ${variantStyles[variant]} ${sizeStyles[size]}`}
    >
      {dot && (
        <span
          className={`w-1.5 h-1.5 rounded-full ${dotColors[variant]}`}
        ></span>
      )}
      {children}
    </span>
  );
};
